import { ChainId, Token } from '@pancakeswap/sdk'

export const PAYW: { [chainId: number]: Token } = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0xD4D123f247027e5856901A2810a4d9d1A34e2140',
    18,
    'PAYW',
    'PayWink',
  ),
  [ChainId.TESTNET]: new Token(
    ChainId.TESTNET,
    '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
    18,
    'PAYW',
    'PancakeSwap Token',
  ),
}
export const USDC: { [chainId: number]: Token } = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    18,
    'USDC',
    'USD Coin (PoS)',
  ),
  [ChainId.TESTNET]: new Token(
    ChainId.TESTNET,
    '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
    18,
    'USDC',
    'USD Coin (PoS)',
  ),
}

export const WMATIC = new Token(ChainId.MAINNET, '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270', 18, 'WMATIC', 'Wrapped MATIC')
export const DAI = new Token(ChainId.MAINNET, '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3', 18, 'DAI', 'Dai Stablecoin')
export const USDT = new Token(ChainId.MAINNET, '0x55d398326f99059fF775485246999027B3197955', 18, 'USDT', 'Tether USD')
export const BTCB = new Token(ChainId.MAINNET, '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', 18, 'BTCB', 'Binance BTC')
export const UST = new Token(
  ChainId.MAINNET,
  '0x23396cF899Ca06c4472205fC903bDB4de249D6fC',
  18,
  'UST',
  'Wrapped UST Token',
)
export const ETH = new Token(
  ChainId.MAINNET,
  '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
  18,
  'ETH',
  'Binance-Peg Ethereum Token',
)
// export const USDC = new Token(
//   ChainId.MAINNET,
//   '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
//   18,
//   'USDC',
//   'Binance-Peg USD Coin',
// )

const tokens = {
  bnb: {
    symbol: 'MATIC',
    projectLink: 'https://www.binance.com/',
  },
  cake: {
    symbol: 'PAYW',
    address: {
      137: '0xD4D123f247027e5856901A2810a4d9d1A34e2140',
      96: '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
    },
    decimals: 18,
    projectLink: 'https://paywinkmatic.netlify.app/',
  },
  wbnb: {
    symbol: 'wMATIC',
    address: {
      137: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
      96: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
    },
    decimals: 18,
    projectLink: 'https://pancakeswap.finance/',
  },
  busd: {
    symbol: 'USDC',
    address: {
      137: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
      96: '',
    },
    decimals: 18,
    projectLink: 'https://www.paxos.com/busd/',
  },
  eth: {
    symbol: 'ETH',
    address: {
      137: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
      96: '',
    },
    decimals: 18,
    projectLink: 'https://ethereum.org/en/',
  },
  dai: {
    symbol: 'DAI',
    address: {
      137: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
      96: '',
    },
    decimals: 18,
    projectLink: 'https://www.makerdao.com/',
  },
  
  uni: {
    symbol: 'UNI',
    address: {
      137: '0xBf5140A22578168FD562DCcF235E5D43A02ce9B1',
      96: '',
    },
    decimals: 18,
    projectLink: 'https://www.makerdao.com/',
  },
  twt: {
    symbol: 'TWT',
    address: {
      137: '0x4b0f1812e5df2a09796481ff14017e6005508003',
      96: '',
    },
    decimals: 18,
    projectLink: 'https://www.makerdao.com/',
  },
  link: {
    symbol: 'LINK',
    address: {
      137: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
      96: '',
    },
    decimals: 18,
    projectLink: 'https://www.makerdao.com/',
  },
  usdt: {
    symbol: 'USDT',
    address: {
      137: '0x55d398326f99059fF775485246999027B3197955',
      96: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    },
    decimals: 18,
    projectLink: 'https://tether.to/',
  },
  ust: {
    symbol: 'UST',
    address: {
      137: '0x23396cF899Ca06c4472205fC903bDB4de249D6fC',
      96: '',
    },
    decimals: 18,
    projectLink: 'https://mirror.finance/',
  },
  btcb: {
    symbol: 'BTCB',
    address: {
      137: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
      96: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    },
    decimals: 18,
    projectLink: 'https://bitcoin.org/',
  },
  ada: {
    symbol: 'ADA',
    address: {
      137: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
      96: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    },
    decimals: 18,
    projectLink: 'https://bitcoin.org/',
  },
  ltc: {
    symbol: 'LTC',
    address: {
      137: '0x4338665cbb7b2485a8855a139b75d5e34ab0db94',
      96: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    },
    decimals: 18,
    projectLink: 'https://bitcoin.org/',
  },
  dot: {
    symbol: 'DOT',
    address: {
      137: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
      96: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    },
    decimals: 18,
    projectLink: 'https://bitcoin.org/',
  },
  trx: {
    symbol: 'TRX',
    address: {
      137: '0x85eac5ac2f758618dfa09bdbe0cf174e7d574d5b',
      96: '0xE02dF9e3e622DeBdD69fb838bB799E3F168902c5',
    },
    decimals: 18,
    projectLink: 'https://bitcoin.org/',
  },
  syrup: {
    symbol: 'PRT',
    address: {
      137: '0x45DEdB28513c4548D02e3392C628a11bDeE9E4dd',
      96: '0xfE1e507CeB712BDe086f3579d2c03248b2dB77f9',
    },
    decimals: 18,
    projectLink: 'https://pancakeswap.finance/',
  },
  
}

export default tokens
